export default {
      id: "login-zpru-usage",
      viewBox: "0 0 15 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#login-zpru-usage",
      toString: function () {
        return this.url;
      }
    }